import { useEffect, useState } from "react";
import axios from "axios";
import "./Vaga.css";
import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";
import {
  useNavigate,
  useParams,
} from "react-router-dom";

export default function Vaga() {
  const navigate = useNavigate();

  const { id } = useParams();

  const [vaga, setVaga] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {
    async function carregarVaga() {
      try {
        setLoading(true);

        const response =
          await axios.get(
            "https://app.eliandroalimentos.com.br/api/vagas/listar"
          );

        const vagaEncontrada =
          response.data.find(
            (v) =>
              Number(v.id) ===
              Number(id)
          );

        if (
          !vagaEncontrada ||
          Number(vagaEncontrada.ativo) === 0
        ) {
          navigate("/portalcandidato", {
            replace: true,
          });
          return;
        }

        setVaga(vagaEncontrada);
      } catch (error) {
        console.error(
          "Erro ao carregar vaga:",
          error
        );
      } finally {
        setLoading(false);
      }
    }

    carregarVaga();
  }, [id]);

  if (loading) {
    return (
      <div className="vaga-page">
        <p
          style={{
            textAlign: "center",
            marginTop: "100px",
          }}
        >
          Carregando vaga...
        </p>
      </div>
    );
  }

  if (!vaga) {
    return (
      <div className="vaga-page">
        <p
          style={{
            textAlign: "center",
            marginTop: "100px",
          }}
        >
          Vaga não encontrada.
        </p>
      </div>
    );
  }

  const tituloVaga = vaga.vaga;

  /*
  <button
      className="btn-primary btn-topo"
      onClick={() =>
        navigate("/candidatar")
      }
    >
      Candidatar-se
    </button>
    */

  return (
    <div className="vaga-page">

      <header className="portal-header">

        <div className="header-left">

          <img
            src={Imagens.Logo}
            alt="Eliandro Alimentos"
            className="logo"
          />

          <span className="divider" />

          <h1>
            Portal do Candidato
          </h1>

        </div>

      </header>



      <div className="vaga-content">
        <div
          className="voltar-link"
          onClick={() => navigate("/portalcandidato")}
        >
          ← Voltar para lista de vagas
        </div>

        <div className="vaga-topo">

          <h3>
            Informações da Vaga
          </h3>

          <div className="vaga-topo-botoes">



            <a
              className="btn-whatsapp btn-topo"
              href={`https://wa.me/551993881431?text=${encodeURIComponent(
                `Olá, gostaria de me candidatar para a vaga ${tituloVaga}`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp
            </a>

            <a
              className="btn-email btn-topo"
              href={`mailto:rh@eliandroalimentos.com.br?subject=${encodeURIComponent(
                `Candidatura - ${tituloVaga}`
              )}&body=${encodeURIComponent(
                `Olá,

Gostaria de me candidatar para a vaga de ${tituloVaga}.

Link da vaga:
https://app.eliandroalimentos.com.br/vaga/${id}

Fico no aguardo.

Obrigado!`
              )}`}
            >
              Email
            </a>

          </div>

        </div>

        {/* CARD PRINCIPAL */}

        <div className="vaga-box">

          <h1>
            {vaga.vaga}
          </h1>

          <p className="vaga-local">
            {vaga.cidade}, RS
          </p>


        </div>

        {/* DESCRIÇÃO */}

        <div className="vaga-descricao">

          <span className="descricao-tab">

            Sobre esta vaga

          </span>

          <div className="descricao-content">

            <p>

              {vaga.desc_vaga}

            </p>

          </div>

        </div>

        {/* RESUMO */}

        <div className="vaga-resumo">



          <div className="resumo-card">

            <h4>
              🏢 Endereço
            </h4>

            <p>
              {vaga.endereco} / {vaga.cidade}, RS
            </p>

          </div>

          <div className="resumo-card">

            <h4>
              ⏰ Horário
            </h4>

            <p>
              {vaga.desc_horario}
            </p>

          </div>

        </div>



        {/* LISTAS */}

        <div className="vaga-listas">

          <div className="lista-box">

            <h5>

              📌 Atividades

            </h5>

            <ul>

              {vaga.atividades?.map(
                (atividade) => (

                  <li key={atividade.id}>

                    {atividade.descricao}

                  </li>

                )
              )}

            </ul>

          </div>

          <div className="lista-box">

            <h5>

              ✅ Requisitos

            </h5>

            <ul>

              {vaga.requisitos?.map(
                (requisito) => (

                  <li key={requisito.id}>

                    {requisito.descricao}

                  </li>

                )
              )}

            </ul>

          </div>

          <div className="lista-box">

            <h5>

              🎁 Benefícios

            </h5>

            <ul>

              {vaga.beneficios?.map(
                (beneficio) => (

                  <li key={beneficio.id}>

                    {beneficio.descricao}

                  </li>

                )
              )}

            </ul>

          </div>

        </div>

      </div>

      <footer className="portal-footer" />

    </div>
  );
}